import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import media from '@activebrands/core-web/config/media';
import overlay from '@activebrands/core-web/libs/overlay';
import RichText, { RichTextPropType } from '@activebrands/core-web/libs/storyblok/RichText';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import { SIGN_UP_STEP_ONE } from 'components/auth/UnauthenticatedOverlay';
import ThemeButton, { ButtonsWrapper } from 'components/buttons/ThemeButton';
import Paragraph from 'components/text/Paragraph';

const InnerWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'auto',

    [media.min['desktop.sm']]: {
        flexDirection: 'row',
    },
});

const Information = styled('div', {
    alignItems: 'center',
    backgroundColor: 'var(--color-bg-checkout-act-information)',
    borderRadius: '8px',
    color: 'var(--color-text-checkout-act-information)',
    display: 'flex',
    justifyContent: 'center',
    padding: '8px',
    marginTop: '12px',
});

const Icon = styled('img', {
    marginRight: '16px',
    flexShrink: 0,
    width: '12px',
    height: '100%',
});

const UnAuthenticatedActRewardsContent = ({
    $style,
    actRewardsParagraph,
    actRewardsusp,
    loginButton,
    signUpButton,
}) => {
    const [css] = useStyletron();

    return (
        <div className={css($style)}>
            <InnerWrapper>
                <div
                    className={css({
                        width: ['100%', null, null, null, '50%'],
                        ...textStyles['Secondary/14_130_-0175'],
                    })}
                >
                    <RichText data={actRewardsParagraph} />
                </div>
                <ButtonsWrapper
                    $style={{
                        display: 'flex',
                        justifyContent: 'flex-stretch',
                        width: '100%',
                        marginTop: '12px',

                        [media.min['desktop.sm']]: {
                            flexDirection: 'row',
                            width: '50%',
                            justifyContent: 'flex-end',
                            marginTop: '0',
                        },
                    }}
                >
                    {loginButton && (
                        <ThemeButton
                            $style={{ flexShrink: 1, width: ['50%', null, null, null, 'auto'] }}
                            fontKeys="Misc/16_100_-02"
                            theme={loginButton.theme}
                            onClick={() => {
                                overlay.open('unauthenticated', {
                                    redirect: false,
                                });
                            }}
                        >
                            {loginButton.label}
                        </ThemeButton>
                    )}
                    {signUpButton && (
                        <ThemeButton
                            $style={{ flexShrink: 1, width: ['50%', null, null, null, 'auto'] }}
                            fontKeys="Misc/16_100_-02"
                            theme={signUpButton.theme}
                            onClick={() => {
                                overlay.open('unauthenticated', {
                                    form: SIGN_UP_STEP_ONE,
                                    resetId: 'new-member',
                                });
                            }}
                        >
                            {signUpButton.label}
                        </ThemeButton>
                    )}
                </ButtonsWrapper>
            </InnerWrapper>
            {actRewardsusp?.label && (
                <Information>
                    {actRewardsusp.icon && <Icon src={actRewardsusp.icon.filename} />}
                    <Paragraph fontKeys="Secondary/14_130">{actRewardsusp.label}</Paragraph>
                </Information>
            )}
        </div>
    );
};

UnAuthenticatedActRewardsContent.propTypes = {
    $style: PropTypes.object,
    actRewardsParagraph: RichTextPropType,
    actRewardsusp: PropTypes.shape({
        icon: PropTypes.shape({
            filename: PropTypes.string,
        }),
        label: PropTypes.string,
    }),
    loginButton: PropTypes.shape({
        label: PropTypes.string,
        theme: PropTypes.string,
    }),
    signUpButton: PropTypes.shape({
        label: PropTypes.string,
        theme: PropTypes.string,
    }),
};

export default UnAuthenticatedActRewardsContent;
